/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Switch_DarkInputs */

const en_theme_switch_dark = /** @type {(inputs: Theme_Switch_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to the dark theme`)
};

/**
* | output |
* | --- |
* | "Switch to the dark theme" |
*
* @param {Theme_Switch_DarkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const theme_switch_dark = /** @type {((inputs?: Theme_Switch_DarkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Switch_DarkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_theme_switch_dark(inputs)
});